import { render, staticRenderFns } from "./RoomDisplays.vue?vue&type=template&id=3bb7de0e&scoped=true&"
import script from "./RoomDisplays.vue?vue&type=script&lang=ts&"
export * from "./RoomDisplays.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDisplays.vue?vue&type=style&index=0&id=3bb7de0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7de0e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb7de0e')) {
      api.createRecord('3bb7de0e', component.options)
    } else {
      api.reload('3bb7de0e', component.options)
    }
    module.hot.accept("./RoomDisplays.vue?vue&type=template&id=3bb7de0e&scoped=true&", function () {
      api.rerender('3bb7de0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomDisplays.vue"
export default component.exports